import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  * components
  * */
import PendingList from '~/components/dashboard/pendingAction/PendingList';
import PendingApproval from '~/components/dashboard/pendingAction/PendingApproval';
import PendingApprovalAddition from '~/components/dashboard/pendingAction/PendingApprovalRange.vue';

/*
  * plugins
   */
import axios from '~/plugins/axios';

export default {
  layout: 'dashBoardLayout',
  name: 'pendingAction',
  components: {
    PendingList: PendingList,
    PendingApproval: PendingApproval,
    PendingApprovalAddition: PendingApprovalAddition
  },
  fetch: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          redirect = _ref.redirect;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!store.state.authUser) {
                redirect('/');
              }

              if (store.state.authUser.flag !== 'Admin') {
                redirect('/dashboard/viewInfo');
              }

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetch(_x) {
      return _ref2.apply(this, arguments);
    }

    return fetch;
  }(),
  data: function data() {
    return {
      // moduleSessionReturned: null,
      // moduleSessionCollection: {},
      // pendingApprovalCollection: {},
      numPdApr: 0
    };
  },
  asyncData: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var returnInfo;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return axios.post('/userMsStatus/getMsByStatus', {
                msStatus: 101
              });

            case 2:
              returnInfo = _context2.sent.data;


              console.log('\n\n ======= dashboard/index.vue <|-- asyncData ======== \n', returnInfo, '\n -----------');

              return _context2.abrupt('return', {
                numPdApr: returnInfo.hasOwnProperty('msStatuses') ? returnInfo['msStatuses'].length : 0
              });

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function asyncData() {
      return _ref3.apply(this, arguments);
    }

    return asyncData;
  }(),
  updated: function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var returnInfo;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return axios.post('/userMsStatus/getMsByStatus', {
                msStatus: 101
              });

            case 2:
              returnInfo = _context3.sent.data;

              this.numPdApr = returnInfo.hasOwnProperty('msStatuses') ? returnInfo['msStatuses'].length : 0;

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function updated() {
      return _ref4.apply(this, arguments);
    }

    return updated;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/dashboard/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/dashboard/index.vue
// module chunks = 1